import {
  COLUNAS_DEFAULT_MODULE_DEPOSITO,
  COLUNAS_DEFAULT_MODULE_EXPEDICAO,
  COLUNAS_DEFAULT_MODULE_FINANCEIRO,
  COLUNAS_DEFAULT_MODULE_MATERIA_PRIMA,
  COLUNAS_DEFAULT_MODULE_MSG_CLICK_MASSA,
  COLUNAS_DEFAULT_MODULE_ORCAMENTO,
  COLUNAS_DEFAULT_MODULE_PARCEIRO,
  COLUNAS_DEFAULT_MODULE_PEDIDO,
  COLUNAS_DEFAULT_MODULE_PRODUCAO,
  COLUNAS_DEFAULT_MODULE_PRODUTO,
  COLUNAS_DEFAULT_MODULE_REPORT_VENDAS,
  COLUNAS_DEFAULT_MODULE_SYSADMIN,
  COLUNAS_DEFAULT_MODULE_SYSADMIN_PRECIFICACAO,
  COLUNAS_DEFAULT_MODULE_SYSADMIN_REPORT_FINANCEIRO,
  COLUNAS_DEFAULT_MODULE_VENDAS
} from '@app/shared/utils/colunas/const';
import { IColunasSettingsUser } from '../validar_settings_user';

export const COLUNAS_DEFAULT_PROJETO = [
  ...COLUNAS_DEFAULT_MODULE_EXPEDICAO,
  ...COLUNAS_DEFAULT_MODULE_PARCEIRO,
  ...COLUNAS_DEFAULT_MODULE_FINANCEIRO,
  ...COLUNAS_DEFAULT_MODULE_MATERIA_PRIMA,
  ...COLUNAS_DEFAULT_MODULE_VENDAS,
  ...COLUNAS_DEFAULT_MODULE_PEDIDO,
  ...COLUNAS_DEFAULT_MODULE_PRODUCAO,
  ...COLUNAS_DEFAULT_MODULE_ORCAMENTO,
  ...COLUNAS_DEFAULT_MODULE_PRODUTO,
  ...COLUNAS_DEFAULT_MODULE_REPORT_VENDAS,
  ...COLUNAS_DEFAULT_MODULE_DEPOSITO,
  ...COLUNAS_DEFAULT_MODULE_MSG_CLICK_MASSA
] as IColunasSettingsUser[];

export const COLUNAS_DEFAULT_SYSDAMIN = [
  ...COLUNAS_DEFAULT_MODULE_SYSADMIN,
  ...COLUNAS_DEFAULT_MODULE_SYSADMIN_PRECIFICACAO,
  ...COLUNAS_DEFAULT_MODULE_SYSADMIN_REPORT_FINANCEIRO
]
